import React, { useState, useEffect } from "react";
import "./ShowScrollCategory.css";

const ShowScrollCategory = ({ onCategorySelection }) => {
  const [categories, setCategories] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [saveSuccess, setSaveSuccess] = useState(false); // To track save success
  const [loading, setLoading] = useState(false); // To handle loading state

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await fetch("https://api.swasthmitra.com/api/category/get");
        const data = await response.json();

        if (response.ok) {
          setCategories(data.categories);

          // Set selected categories from the fetched categories where `isScrollSelected` is true
          const selectedIds = data.categories
            .filter((category) => category.isScrollSelected)
            .map((category) => category._id);
          setSelectedCategories(selectedIds);
        } else {
          console.error("Error fetching categories:", data.message);
        }
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };

    fetchCategories();
  }, []);

  const handleCheckboxChange = (categoryId) => {
    setSelectedCategories(
      (prevState) =>
        prevState.includes(categoryId)
          ? prevState.filter((id) => id !== categoryId) // Remove from selected
          : [...prevState, categoryId] // Add to selected
    );
  };

  const handleSave = async () => {
    setLoading(true); // Start loading
    setSaveSuccess(false); // Reset previous save success message

    try {
      // Update each category's `isScrollSelected` value in the backend
      for (let category of categories) {
        const isScrollSelected = selectedCategories.includes(category._id);
        await fetch("https://api.swasthmitra.com/api/category/updateSelection", {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ id: category._id, isScrollSelected }),
        });
      }

      // Call the parent function to pass the selected categories to the slider
      onCategorySelection(selectedCategories);

      setSaveSuccess(true); // Show success message
    } catch (error) {
      console.error("Error saving selected categories:", error);
      setSaveSuccess(false); // If there is an error, ensure no success message is shown
    } finally {
      setLoading(false); // Stop loading
    }
  };

  return (
    <div className="show-scroll-category-section">
      <h3>Select Categories for Scrollable Slider</h3>
      <div className="category-selection">
        {categories.map((category) => (
          <div key={category._id}>
            <label>
              <input
                type="checkbox"
                checked={selectedCategories.includes(category._id)}
                onChange={() => handleCheckboxChange(category._id)}
              />
              {category.name}
            </label>
          </div>
        ))}
      </div>
      <button onClick={handleSave} disabled={loading} className="btn">
        {loading ? "Saving..." : "Save Selected Categories"}
      </button>

      {saveSuccess && !loading && (
        <div className="success-message">Categories saved successfully!</div>
      )}
    </div>
  );
};

export default ShowScrollCategory;
